import { featuresData } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">为什么选择我们</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">三大核心优势，给你最专业的吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group text-center p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}